import axios from "@/utils/api-v1.js"
import { clearLocalStorageKeepingUtmParams } from "@/utils/utmParams"

export default {
  login(email, pwd) {
    return axios.post("/api/auth/login", {
      email,
      password: pwd,
    })
  },
  registerUser(name, email, pwd) {
    return axios.post("/api/users", {
      displayName: name,
      email,
      password: pwd,
    })
  },
  refreshToken() {
    return axios.post("/api/auth/refresh-token")
  },
  claimAccount(token, password) {
    return axios.post("/api/auth/claim-account", { token, password })
  },
  resendClaim(email) {
    return axios.post("/api/auth/resend-claim", { email })
  },
  // company: { companyName, zip, categories } from /hire (GFB-1413), so a
  // company signing up with Google gets its company profile created.
  googleAuth(idToken, profileType, company) {
    return axios.post("/api/auth/google", {
      idToken,
      profileType,
      ...(company ?? {}),
    })
  },
  verifyGoogleCode(email, code) {
    return axios.post("/api/auth/google/verify", { email, code })
  },
  resendGoogleCode(email) {
    return axios.post("/api/auth/google/resend", { email })
  },
  revokeToken() {
    try {
      const response = axios.post("/api/auth/revoke-token")
      if (response.status === 401 || response.status === 403) {
        clearLocalStorageKeepingUtmParams()
      }
    } catch (error) {
      const status = error.response?.status
      if (status === 401 || status === 403) {
        clearLocalStorageKeepingUtmParams()
        this.$router.replace({ path: "/login" })
      }

      // Re-throw so Vuex action can also handle it
      throw error
    }
  },
}
